import React from "react";
import { Modal, Button } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles/index";
import { reset2fa } from "../_redux/groupsCrud";

const useStyles = makeStyles({
    text: {
        fontSize: "1.2rem",
        color: "#000000",
        margin: "0",
    }
});

export default function Reset2fa({ show, onHide, id, setShowQrView, setBase64 }) {
    const classes = useStyles();

    const onReset2fa = async () => {
        try {
            const response = await reset2fa(id);
            setShowQrView(true);
            setBase64(response.data?.qrPngBase64);
            onHide(false);
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            centered
        >
            <Modal.Body>
                <p className={classes.text}>2FA kodunu yeniləmək istədiyinizdən əminsiniz?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={() => onHide(false)}>
                    Bağla
                </Button>
                <Button onClick={onReset2fa}>Yenilə</Button>
            </Modal.Footer>
        </Modal>
    );
}
